// extracted by mini-css-extract-plugin
module.exports = {"Player":"Player_Player__lNMs9"};